// The moment a bet ends: the table shows a win in gold and a bust in red, once, over everything.

import { createStore } from "../state/store";

export type Moment = { id: number; kind: "win" | "bust"; amount: string; label: string; multiple: string };

export const moment = createStore<Moment | null>(null);

let next = 1;

export function celebrate(kind: Moment["kind"], amount: string, label: string, multiple = "") {
  moment.set({ id: next++, kind, amount, label, multiple });
}

// the dev server can call a moment by hand, to see one without betting
if (import.meta.env.DEV) (window as unknown as { hypaMoment: typeof celebrate }).hypaMoment = celebrate;
